import React, { useRef, useState } from 'react';
import Card from 'v3/components/Card';
import Button from 'v3/components/Button';
import Fields from './Fields';
import Summary, { StatusPill } from './Summary';
import { CardTitle } from '.';
import {
  changeForm,
  fromResponse,
  initialForm,
  sameSettings,
  toPayload,
  validateForm,
} from './form';
import { controlTowerService, errorMessage } from './service';

export function useControlTowerCreation(type) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [existing, setExisting] = useState(null);
  const [createdId, setCreatedId] = useState(null);
  const state = useRef({ id: null, busy: false, uncertain: false, complete: false });
  async function submit(create) {
    if (state.current.busy) return false;
    const invalid = validateForm(form);
    setErrors(invalid);
    if (Object.keys(invalid).length) {
      setMessage('Revise os campos de Disponibilidade e Recusas.');
      return false;
    }
    state.current.busy = true;
    setBusy(true);
    setMessage('');
    try {
      if (!state.current.id) {
        const id = await create();
        if (!id) return false;
        state.current.id = id;
        setCreatedId(id);
      }
      const { id } = state.current;
      if (state.current.complete) return id;
      if (state.current.uncertain) {
        const current = await controlTowerService.read(type, id);
        if (current.initialized || state.current.denied) {
          if (!state.current.denied && sameSettings(form, fromResponse(current))) {
            state.current.complete = true;
            return id;
          }
          setExisting(current);
          setMessage(
            'Compare a configuração atual. Você pode mantê-la e concluir o cadastro; alterações devem ser feitas na edição da placa com a permissão correspondente.',
          );
          return false;
        }
      }
      state.current.uncertain = true;
      const result = await controlTowerService.save(type, id, toPayload(form), true);
      fromResponse(result);
      state.current.complete = true;
      return id;
    } catch (error) {
      // O cadastro principal mantém seu tratamento de erros e validações existente.
      if (!state.current.id) throw error;
      const code = error?.response?.status;
      if (code === 422) state.current.uncertain = false;
      if (code === 403) state.current.denied = true;
      setMessage(
        `${state.current.id ? 'A placa foi salva; falta concluir a disponibilidade. ' : ''}${errorMessage(error)}`,
      );
      if (error?.response?.data?.field)
        setErrors({ [error.response.data.field]: errorMessage(error) });
      return false;
    } finally {
      state.current.busy = false;
      setBusy(false);
    }
  }
  return {
    form,
    errors,
    busy,
    message,
    existing,
    createdId,
    submit,
    change: (field, value) => {
      if (!state.current.complete) setForm((old) => changeForm(old, field, value));
      setErrors({});
    },
    useExisting: () => {
      setForm(fromResponse(existing));
      setExisting(null);
      state.current.complete = true;
      setMessage('Configuração salva mantida. Clique em Salvar para concluir o cadastro.');
    },
    complete: state.current.complete,
  };
}
export default function ControlTowerCreation({ control }) {
  return (
    <Card header={<CardTitle />} bodyCardPadding="24px">
      {control.message && <p role="alert">{control.message}</p>}
      {control.createdId && (
        <p>
          Placa cadastrada (código {control.createdId}). Ao salvar novamente, será concluída somente
          a configuração pendente.
        </p>
      )}
      {control.existing && (
        <div style={{ background: '#fff7df', padding: 16, marginBottom: 20 }}>
          <p>
            Configuração já salva: <StatusPill data={control.existing} />
          </p>
          <Summary form={fromResponse(control.existing)} />
          <Button variant="secondary" onClick={control.useExisting}>
            Manter configuração já salva
          </Button>
        </div>
      )}
      <Fields
        form={control.form}
        change={control.change}
        errors={control.errors}
        disabled={control.busy || control.complete}
      />
    </Card>
  );
}
